$(document).ready(function () {
$('.slider-for-product').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav-product'
});
$('.slider-nav-product').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for-product',
    dots: false,
    centerMode: false,
    arrows: false,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint: 750,
            settings: {
                slidesToShow: 5
            }
        }
    ]
});

// 7 high
    $('.ingredients_slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        }, {
            breakpoint: 360,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});

    //Counter
    document.querySelectorAll('.counter').forEach(counter => {
        new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                let i = 75;
                let target = +counter.dataset.count;
                let timer = setInterval(() => {
                    counter.textContent = ++i + '%';
                    if (i >= target) clearInterval(timer);
                }, 20);
            }
        }, { threshold: 0.5 }).observe(counter);
    });

    //Real Reviews Slider
        var $slider = $('.real-reviews-slider');
        var $progress = $('.progress');
        $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
            var current = currentSlide !== undefined ? currentSlide : 0;
            var total = slick.slideCount;
            var percent = ((current + 1) / total) * 100;
            $progress.css('width', percent + '%');
            $progress.attr('aria-valuenow', Math.round(percent));
        });
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0px',
            dots: false,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

    // faq accordians
    document.querySelectorAll(".diamond-faq-question").forEach(btn => {
        btn.addEventListener("click", () => {
            const item = btn.closest(".diamond-faq-item");
            const answer = item.querySelector(".diamond-faq-answer");
            const container = item.parentElement;
            container.querySelectorAll(".diamond-faq-item").forEach(el => {
                if (el !== item) {
                    el.classList.remove("active");
                    el.querySelector(".diamond-faq-answer").style.maxHeight = null;
                }
            });
            item.classList.toggle("active");
            if (item.classList.contains("active")) {
                answer.style.maxHeight = answer.scrollHeight + "px";
            } else {
                answer.style.maxHeight = null;
            }
        });
    });

    // Sticky Bottom Bar
    $(function () {
        const $sticky = $('.sticky_atc-new'),
            $body = $('body');
        const toggleSticky = () => {
            const show = $(window).scrollTop() >= (window.innerWidth <= 768 ? 1400 : 900);
            $sticky.toggleClass('hide', !show);
            $body.css('padding-bottom', show ? $sticky.outerHeight() : 0);
        };
        $(window).on('scroll resize', toggleSticky);
        toggleSticky();
    });

//Check the radio button plans
document.querySelectorAll('.easy-tiger-content label').forEach(function (label) {
label.addEventListener('click', function () {
    const radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    // NEW: Update button subscription id
    const subscriptionId = radio.getAttribute('data-subscriptionid');
    const proqty = radio.getAttribute('data-proqty');
     const variantid = radio.getAttribute('data-variantid');
     const freeebook = radio.getAttribute('data-freeebook');
     const btnlabel = radio.getAttribute('data-btnlabel');
    if (subscriptionId) {
        document
            .querySelector('.ajax_stickybtn_mainbtn')
            .setAttribute('data-subscriptionid', subscriptionId);
         document
            .querySelector('.ajax_stickybtn_mainbtn')
            .setAttribute('data-proqty', proqty);
        document
            .querySelector('.ajax_stickybtn_mainbtn')
            .setAttribute('data-variantid', variantid);
        document
            .querySelector('.ajax_stickybtn_mainbtn')
            .setAttribute('data-freeebook', freeebook);
        document.querySelector('.ajax_stickybtn_mainbtn').textContent= btnlabel;
    }
    // Remove selected + active from all
    document.querySelectorAll('.easy-tiger-content .plan-radio').forEach(function (el) {
        el.classList.remove('selected');
    });
    document.querySelectorAll('.easy-tiger-content label').forEach(function (el) {
        el.classList.remove('active');
    });
    // Add selected + active to clicked
    const indicator = label.querySelector('.plan-radio');
    if (indicator) indicator.classList.add('selected');
    label.classList.add('active');

    // remove disabled class
    $('#ajax_atc_earlytiger').removeClass('disabled');
});
});

// atc button
// Product artillary structure
// Add SPLP Product to Cart
function AddtoCartSPLP(button,SPLPPageHandle) {
   var variantId = $(button).data('variantid');
   var sellingPlanId = $(button).attr('data-subscriptionid');
   var freegiftid = $(button).data('ebookvariantid');
   var proqty = $(button).data('proqty');
   var freeebook = $(button).data('freeebook');
   //alert(button);
   // Validation
    if (!variantId) {
        console.error('Variant ID missing');
        $('#ajax_atc_earlytiger').removeClass('disabled');
        return;
    }
    var items = [];
    // Main Product
    var item = {
        id: Number(variantId),
        quantity: proqty
    };
    if (sellingPlanId) {
        item.selling_plan = Number(sellingPlanId),
        item.properties = {
                _splpmainproduct: SPLPPageHandle,
                _freeShippingProductOffer: 'easylipolaser'
            };
    }
    items.push(item);
    if (freegiftid && freeebook == 'yes' ) {
        var giftItem = {
            id: Number(freegiftid),
            quantity: 1
        };
        if (sellingPlanId) {
            giftItem.properties = {
                _smgift: '1'
            };
        }
        items.push(giftItem);
    }
    console.log('Adding Items:', items);
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({
            items: items
        }),
        contentType: 'application/json',
        dataType: 'json',
        success: function(response) {
            console.log('Added to cart:', response);
            // Redirect to checkout
            $('#ajax_atc_earlytiger').removeClass('disabled');
            window.location.href = '/checkout';
        },
        error: function(xhr) {
            console.error('Error adding to cart:', xhr.responseText);
            $('#ajax_atc_earlytiger').removeClass('disabled');
        }
    });
}
// Change the cart according to requirementes

// remove old items ajax
  function removeOldItems(keys,SPLPPageHandle,button) {
  var CurrentPageHandle = window.location.pathname.split('/').pop();
  var updates = {};
  keys.forEach(function(key) {
      updates[key] = 0; // set lineitme value to zero
  });
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: updates },
      dataType: 'json',
      success: function() {
        console.log('Old Items are removed');
        if(SPLPPageHandle == CurrentPageHandle){
          AddtoCartSPLP(button,SPLPPageHandle);
        }else{
         window.location.replace('/cart');
        }
      },
      error: function(err) {
          $('#atc_bundle').addClass('disabled');
          console.error('Error removing items:', err);
      }
  });
  }
// remove old itmes ends

// Change the cart according to requirementes 
  function CartChagne(button,SPLPPageHandle){
    $.getJSON('/cart.js', function(cart) {
      //alert("Cart Change");
      var itemsToRemove = [];
      cart.items.forEach(function(item) {
          // Find items by property
          console.log(item.properties.Role);
          if (item.properties._splpmainproduct === "easy-tiger-offer" || item.properties._splpmainproduct === "laser-spot-offer" || item.properties._splpmainproduct === "lipo-torch-offer" || item.properties._smgift === "1") {
                itemsToRemove.push(item.key); // push to array item.key
                //alert(itemsToRemove);
          }
      });
      if (itemsToRemove.length) {
          console.log(itemsToRemove,SPLPPageHandle,button);
          removeOldItems(itemsToRemove,SPLPPageHandle,button);
      }else{
        AddtoCartSPLP(button,SPLPPageHandle);
            //alert("Run Add function");
      }
    });
  }
// atc_bundle buttno clicked 
$(document).on('click', '#ajax_atc_earlytiger', function(e) {
    var SPLPPageHandle = window.location.pathname.split('/').pop();
    var button = $(this);
    e.preventDefault();
    if ($(this).hasClass('disabled')) {
        return;
    }
    $(this).addClass('disabled');
    //AddtoCartSPLP(this);
    CartChagne(button,SPLPPageHandle);
});
// Ends button click
});

// js codes
function toggleDropdown() {
    const menu = document.getElementById('ddMenu');
    const trigger = document.getElementById('ddTrigger');
    const isOpen = menu.classList.contains('open');
    menu.classList.toggle('open', !isOpen);
    trigger.classList.toggle('open', !isOpen);
}

function selectOption(el) {
    document.querySelectorAll('.dd-option').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    const label = el.dataset.label;
    const price = el.dataset.price;
    const was = el.dataset.was;
    const per = el.dataset.per;
    const subid = el.dataset.subid;
    const proqty = el.dataset.proqty;
    const variantid = el.dataset.variantid;
    const freeebook = el.dataset.freeebook;
    
    document.getElementById('triggerLine1').textContent = label;
    document.getElementById('triggerLine2').innerHTML =
        `<span class="price-now">${price}</span>` +
        (was ? `<span class="price-was">${was}</span>` : '') +
        (per ? `<span>(${per})</span>` : '');
    document.getElementById('ddMenu').classList.remove('open');
    document.getElementById('ddTrigger').classList.remove('open');

    // Update button subscription id
    const atcBtn = $('.ajax_stickybtn');
    if (subid && subid.trim() !== '') {
        atcBtn.attr('data-subscriptionid', subid);
        atcBtn.attr('data-proqty', proqty);
        atcBtn.attr('data-variantid', variantid);
        atcBtn.attr('data-freeebook', freeebook);
    } else {
        atcBtn.removeAttr('data-subscriptionid');
        atcBtn.removeAttr('data-proqty');
        atcBtn.attr('data-variantid', variantid);
        atcBtn.removeAttr('data-freeebook'); 
    }
    console.log(
        'Updated Subscription ID:',
        atcBtn.attr('data-subscriptionid')
    );
    $('#ajax_atc_earlytiger').removeClass('disabled');
}

// Close on outside click
document.addEventListener('click', function (e) {
    const trigger = document.getElementById('ddTrigger');
    const menu = document.getElementById('ddMenu');
    if (!trigger.contains(e.target) && !menu.contains(e.target)) {
        menu.classList.remove('open');
        trigger.classList.remove('open');
    }
});